<div class="cargando" *ngIf="isLoading$ | async" class="cargando">
  Cargando<span class="puntos">...</span>
</div>

<router-outlet></router-outlet>
